import axios from "axios";

const dataQualityAnalysisURL = "/api/v1/data_quality_analysis";

const dataQualityAnalysisApis = {
  analysis: id => axios.get(`${dataQualityAnalysisURL}/${id}`),
  table_view: (id, page, per) =>
    axios.get(
      `${dataQualityAnalysisURL}/${id}/table_view?page=${page}&per=${per}`
    ),
  quality_rules_metrics: id =>
    axios.get(`${dataQualityAnalysisURL}/${id}/quality_rules_metrics`),
};

export default dataQualityAnalysisApis;
